import type { Maybe } from '@soundxyz/utils';
import { gql, IsChannelCuratorDocument, useQuery } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query isChannelCurator($input: QueryIsChannelCuratorInput!) {
    isChannelCurator(input: $input) {
      __typename
      channelId
      result
      role
    }
  }
`);

export function useIsChannelCurator({ channelId }: { channelId: Maybe<string> }) {
  const { data, isLoading } = useQuery(IsChannelCuratorDocument, {
    variables: !!channelId && {
      input: {
        channelIds: [channelId],
      },
    },
    staleTime: 0,
  });

  const isChannelCurator = data?.data.isChannelCurator[0]?.result;
  const isChannelOwner = data?.data.isChannelCurator[0]?.role === 'OWNER';

  return { isLoading, isChannelCurator, isChannelOwner };
}
